// 詳細設計書(自前e-meshシステム)_UI連携RESTAPI編v1.14.doc に準拠し、実装
export type Authority = 1 | 2 | 3 | 4 | 5 | 10 | 20 | 30 | 101;

// ユーザーグループ権限情報
export type UsergroupAuthorityInfo = {
  authority: number;
  authorityName: string;
};

const isAdmin = (authority: Authority): boolean => {
  return (
    authority === 1 ||
    authority === 2 ||
    authority === 3 ||
    authority === 4 ||
    authority === 5
  );
};

const isMainte = (authority: Authority): boolean => {
  return authority === 10;
};

const isMatter = (authority: Authority): boolean => {
  return authority === 20;
};

const isArea = (authority: Authority): boolean => {
  return authority === 30;
};

const isStoreUser = (authority: Authority): boolean => {
  return authority === 101;
};

const isNotStoreUser = (authority: Authority): boolean => {
  return authority < 101;
};

export function getPermission(authority: Authority) {
  return {
    isAdmin: isAdmin(authority),
    isMainte: isMainte(authority),
    isMatter: isMatter(authority),
    isArea: isArea(authority),
    isStoreUser: isStoreUser(authority),
    isNotStoreUser: isNotStoreUser(authority)
  };
}

export function getUsergroupAuthorityInfos(): UsergroupAuthorityInfo[] {
  return [
    {
      authority: 1,
      authorityName: "システム管理者"
    },
    {
      authority: 10,
      authorityName: "保守メンテナンス員"
    },
    {
      authority: 20,
      authorityName: "案件管理者"
    },
    {
      authority: 30,
      authorityName: "エリア管理者"
    }
  ];
}
